<script setup>
import { computed, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// advup — marca FIXA no código. NUNCA mostra o logo do Chatwoot, mesmo que o
// InstallationConfig (LOGO_THUMBNAIL) reverta pro default do Chatwoot via seed.
// Se o logoThumbnail estiver vazio ou for um asset do Chatwoot, força o ícone advup.
const ADVUP_ICON = '/brand-assets/advup-icon-ref.png';
const logoSrc = computed(() => {
  const t = globalConfig.value?.logoThumbnail || '';
  if (!t || /logo_thumbnail|chatwoot|woot/i.test(t)) return ADVUP_ICON;
  return t;
});
</script>

<template>
  <img v-bind="attrs" :src="logoSrc" alt="advup" />
</template>
